import { Badge } from "@/components/ui/Badge"

export function PlanBadge({ isPro }: { isPro: boolean }) {
  return (
    <Badge
      className="tw-w-16 tw-justify-center"
      variant={isPro ? "default" : "secondary"}
    >
      {isPro ? "Pro" : "Basic"}
    </Badge>
  )
}
